<article
  #wrapper
  class="image normal"
  [style.--percentage-scale]="(percentageScale || MAX_PERCENT) + '%'"
  [class.vertical-scroll]="this.imageMetaData?.verticalScroll"
  [class.horizontal-scroll]="this.imageMetaData?.horizontalScroll"
  [class.zoomed]="!this.imageMetaData?.maximumZoom || this.imageMetaData?.maximumZoom !== 1"
>
  <img
    txtbProportionalImage
    #img
    [isScrolled]="this.imageMetaData?.verticalScroll"
    (load)="adjustImageSize(wrapper, img)"
    decoding="auto"
    draggable="false"
    (dragstart)="$event.preventDefault()"
    [alt]="alt"
    txtbFixRender
    [imgSrc]="imageSrc[0]"
    [src]="imageSrc[0]"
    [attr.sub]="imageSrc[0]"
    [class.responsive]="
      !imageMetaData?.verticalScroll && !imageMetaData?.horizontalScroll
    "
    [class.scale-to-height]="!imageMetaData?.verticalScroll
    && imagesScalingEnabled
    && (imageMetaData?.horizontalScroll || (scaleImageToHeight$ | async) === true)"
    [class.scale-to-width]="!imageMetaData?.horizontalScroll
    && imagesScalingEnabled
    && (imageMetaData?.verticalScroll || (scaleImageToWidth$ | async) === true)"
  />
</article>
